export const LeftLines = () => {
    return (
        <svg
            width="193"
            height="109"
            viewBox="0 0 193 109"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M132.5 -3.83786e-05L-87 0L-87 19L132.5 19C137.747 19 142 14.7467 142 9.49996C142 4.25325 137.747 -3.9296e-05 132.5 -3.83786e-05Z"
                fill="url(#line1_left_gradiant_color)"
            />
            <path
                d="M49.5 64L183.5 64C188.747 64 193 59.7467 193 54.5C193 49.2533 188.747 45 183.5 45L49.5 45C44.2533 45 40 49.2533 40 54.5C40 59.7467 44.2533 64 49.5 64Z"
                fill="url(#line2_left_gradiant_color)"
            />
            <path
                d="M88.5 90H-42V109H88.5C93.7467 109 98 104.747 98 99.5C98 94.2533 93.7467 90 88.5 90Z"
                fill="url(#line3_left_gradiant_color)"
            />
            <defs>
                <linearGradient
                    id="line1_left_gradiant_color"
                    x1="-87"
                    y1="9.5"
                    x2="142"
                    y2="9.49996"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" stopOpacity="0.77" />
                    <stop
                        offset="0.519737"
                        stopColor="white"
                        stopOpacity="0.25"
                    />
                    <stop offset="1" stopColor="white" stopOpacity="0.73" />
                </linearGradient>
                <linearGradient
                    id="line2_left_gradiant_color"
                    x1="193"
                    y1="54.5"
                    x2="40"
                    y2="54.5"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#C9F2FF" />
                    <stop
                        offset="0.557292"
                        stopColor="#C9F2FF"
                        stopOpacity="0.54"
                    />
                    <stop
                        offset="0.9999"
                        stopColor="#C9F2FF"
                        stopOpacity="0.16"
                    />
                    <stop offset="1" stopColor="#C9F2FF" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id="line3_left_gradiant_color"
                    x1="-42"
                    y1="99.5"
                    x2="98"
                    y2="99.5"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#EAE6FF" stopOpacity="0" />
                    <stop
                        offset="0.0001"
                        stopColor="#F1F3FF"
                        stopOpacity="0.290176"
                    />
                    <stop
                        offset="0.265625"
                        stopColor="#EFEFFF"
                        stopOpacity="0.505208"
                    />
                    <stop offset="0.890625" stopColor="#EAE6FF" />
                </linearGradient>
            </defs>
        </svg>
    );
};
